import * as yup from 'yup'

const FormSchemaValidations = yup.object().shape({
  reset_main_admin_password: yup.string().test('passwords-rules', 'La contraseña debe tener al menos 8 caracteres, una letra mayúscula y un caracter especial', (value) => {
    const regex = /^(?=.*[A-Z])(?=.*[\W_]).{8,}$/i
    return regex.test(value)
  }),
})

export default FormSchemaValidations